import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { PageMeta } from "@/components/PageMeta";
import { DEFAULT_SOCIAL_IMAGE, NOT_FOUND_META, PAGE_META, SITE_ORIGIN, siteSchemas } from "@/lib/seo";
import Home from "@/pages/Home";
import OperationalClarity from "@/pages/OperationalClarity";
import HowBosWorks from "@/pages/HowBosWorks";
import BOSReveal from "@/pages/BOSReveal";
import OperationalClarityReview from "@/pages/OperationalClarityReview";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import ExecutiveGuide from "@/pages/ExecutiveGuide";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import SubscriptionConfirmed from "@/pages/SubscriptionConfirmed";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SiteMeta = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/insights/")) return null;
  const meta = PAGE_META[pathname] || NOT_FOUND_META;
  return <PageMeta {...meta} canonical={`${SITE_ORIGIN}${pathname}`} image={DEFAULT_SOCIAL_IMAGE} schemas={siteSchemas(pathname)} />;
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <SiteMeta />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/operational-clarity" element={<OperationalClarity />} />
          <Route path="/how-bos-works" element={<HowBosWorks />} />
          <Route path="/bos-reveal" element={<BOSReveal />} />
          <Route path="/friction-review" element={<Navigate to="/bos-reveal" replace />} />
          <Route path="/operational-clarity-review" element={<OperationalClarityReview />} />
          <Route path="/clarity-review" element={<Navigate to="/operational-clarity-review" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/why-capable-teams-produce-inconsistent-results" element={<Navigate to="/insights/capable-teams-inconsistent-execution" replace />} />
          <Route path="/insights/operational-friction-extra-work-surrounding-work" element={<Navigate to="/insights/strong-manager-hide-weak-operating-system" replace />} />
          <Route path="/insights/:slug" element={<InsightArticle />} />
          <Route path="/executive-guide" element={<ExecutiveGuide />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/subscription-confirmed" element={<SubscriptionConfirmed />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
